/**
 * Surface Type Service
 * Nomenclator suprafețe per organizație pentru probe ATP și Lab.
 */

import { db } from '../firebase';
import {
  collection, doc, addDoc, updateDoc, getDocs,
  query, where, orderBy, serverTimestamp
} from 'firebase/firestore';

const COLLECTION = 'surface_types';

const SURFACE_TYPES_SEED = [
  { name: 'Pardoseală', code: 'PARD', sort_order: 1 },
  { name: 'Mâner pat', code: 'MAN_PAT', sort_order: 2 },
  { name: 'Masă de tratament', code: 'MAS_TR', sort_order: 3 },
  { name: 'Masă uscare sterilă', code: 'MAS_ST', sort_order: 4 },
  { name: 'Noptieră', code: 'NOPT', sort_order: 5 },
  { name: 'Tăblie pat', code: 'TAB_PAT', sort_order: 6 },
  { name: 'Chiuvetă', code: 'CHIUV', sort_order: 7 },
  { name: 'Interior europubelă', code: 'EUR', sort_order: 8 },
  { name: 'Interior frigider', code: 'FRIG', sort_order: 9 },
  { name: 'Salon', code: 'SAL', sort_order: 10 },
  { name: 'Asistentă medicală', code: 'ASIST', sort_order: 11 },
  { name: 'Filtru apă sterilă', code: 'FILT_APA', sort_order: 12 }
];

export async function getSurfaceTypes(organizationId) {
  try {
    const q = query(
      collection(db, COLLECTION),
      where('organization_id', '==', organizationId),
      where('is_active', '==', true),
      orderBy('sort_order', 'asc')
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (err) {
    console.error('[surfaceTypeService] getSurfaceTypes:', err);
    throw err;
  }
}

export async function getAllSurfaceTypes(organizationId) {
  try {
    const q = query(
      collection(db, COLLECTION),
      where('organization_id', '==', organizationId),
      orderBy('sort_order', 'asc')
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (err) {
    console.error('[surfaceTypeService] getAllSurfaceTypes:', err);
    throw err;
  }
}

export async function createSurfaceType(organizationId, data, userId) {
  try {
    const docRef = await addDoc(collection(db, COLLECTION), {
      organization_id: organizationId,
      name: data.name.trim(),
      code: data.code?.trim() || '',
      is_active: true,
      sort_order: data.sort_order || 99,
      created_at: serverTimestamp(),
      created_by: userId
    });
    return docRef.id;
  } catch (err) {
    console.error('[surfaceTypeService] createSurfaceType:', err);
    throw err;
  }
}

export async function updateSurfaceType(id, data, userId) {
  try {
    await updateDoc(doc(db, COLLECTION, id), {
      ...data,
      updated_at: serverTimestamp(),
      updated_by: userId
    });
  } catch (err) {
    console.error('[surfaceTypeService] updateSurfaceType:', err);
    throw err;
  }
}

export async function deactivateSurfaceType(id, userId) {
  try {
    await updateDoc(doc(db, COLLECTION, id), {
      is_active: false,
      updated_at: serverTimestamp(),
      updated_by: userId
    });
  } catch (err) {
    console.error('[surfaceTypeService] deactivateSurfaceType:', err);
    throw err;
  }
}

export async function seedSurfaceTypes(organizationId, userId) {
  try {
    const existing = await getAllSurfaceTypes(organizationId);
    if (existing.length > 0) return;

    for (const st of SURFACE_TYPES_SEED) {
      await addDoc(collection(db, COLLECTION), {
        organization_id: organizationId,
        name: st.name,
        code: st.code,
        is_active: true,
        sort_order: st.sort_order,
        created_at: serverTimestamp(),
        created_by: userId
      });
    }
    console.log(`✅ [surfaceTypeService] Seeded ${SURFACE_TYPES_SEED.length} surface types for org ${organizationId}`);
  } catch (err) {
    console.error('[surfaceTypeService] seedSurfaceTypes:', err);
    throw err;
  }
}

export const surfaceTypeService = {
  getSurfaceTypes,
  getAllSurfaceTypes,
  createSurfaceType,
  updateSurfaceType,
  deactivateSurfaceType,
  seedSurfaceTypes
};

export default surfaceTypeService;
